import pathToRegex from 'path-to-regexp';
import type {Key, PathFunction, Token} from 'path-to-regexp';

/*
 * Thin seam over path-to-regexp v1 -- the same major react-router 5 uses
 * internally for matchPath -- so route parsing, compiling and matching all
 * share one grammar, and so tests can spy on the boundary.
 *
 * v1 treats an unescaped "+" in a route as a literal, so routes such as
 * "/:platform/terms+and+conditions" need no normalization.
 */
export const compileRoutePath = (route: string): PathFunction =>
    pathToRegex.compile(route);

export const parseRoutePath = (route: string): Token[] =>
    pathToRegex.parse(route);

export const routePathToRegexp = (route: string, keys?: Key[]): RegExp =>
    pathToRegex(route, keys);
